module.exports = __webpack_public_path__ + "static/media/art12.38c89bc9.png";